<div
	#MainElement
	id="{{ id }}"
	style="display: flex"
	[class.is-disabled]="isDisabled"
	[ngClass]="classList"
	[ngStyle]="{ 'font-size': fontSize, 'line-height': 'calc(24 / 14 * ' + fontSize + ')', 'font-weight': fontWeightNum }"
	[style.color]="customColor ? textColor : null"
	[title]="tooltip ? tooltip : ''"
>
	<ada-container
		[adaClick]="emitInheritanceChange.bind(this)"
		[class.ada-cursor-pointer]="!inheriting"
		[horizontalAlignmentOfChildren]="'center'"
		[isDisabled]="isDisabled"
		[ngStyle]="{ marginRight: _widgetService.ui.Spacing.SPACING_LARGE, width: '0px' }"
		[tooltip]="
			inheriting ? inheritingText || 'This property is set to default and will inherit from parent object if available' : 'Set to default value'
		"
	>
		@if (!isRequired || canInheritWhenRequired) {
			<ada-icon
				[color]="inheriting ? 'foreground' : 'primary'"
				[icon]="inheriting ? 'faArrowSquareUpOutline' : 'faArrowSquareUp'"
				[isDisabled]="isDisabled || inheriting ? true : false"
			/>
		}
	</ada-container>
	@if (renderHTML) {
		<div [innerHTML]="(content ? content : '') | safe: 'html'"></div>
	} @else {
		{{ content }}
	}
	@if (infoText) {
		<ada-signpost [ngStyle]="{ 'margin-left': _widgetService.ui.Spacing.SPACING_XSMALL }">
			<ng-content select="[data-container-selector=label-info-text]" />
		</ada-signpost>
	}
	@if (isRequired) {
		<span
			class="ada-color-accent"
			title="Required"
			[ngStyle]="{ 'margin-left': _widgetService.ui.Spacing.SPACING_XSMALL }"
		>
			*
		</span>
	}
</div>
